export const EST_TIMEZONE = 'America/Detroit';
export const PST_TIMEZONE = 'America/Los_Angeles';

/**
 * Gets the system's default timezone
 * This is the timezone that will be used when a user's timezone preference is not set
 * @returns The IANA timezone identifier (e.g., 'America/New_York')
 */
export const getDefaultTimeZone = (): string => {
  return Intl.DateTimeFormat().resolvedOptions().timeZone;
};

/**
 * The default timezone constant for use throughout the application
 * Represents the system's default timezone when user preferences are not available
 */
export const DEFAULT_TIME_ZONE = getDefaultTimeZone();
